<template>
  <div class="content">
    <div class="urlModel" v-for="item of paperList" :key="item.id">
      <span style="color:#2caf7a;cursor: pointer;" @click="goToUrl(item.id)">
        {{ item.title }}
      </span>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "ExamPaperList",
  components: {},
  data() {
    return {
      paperList: [],
    };
  },

  created() {
    console.log(JSON.parse(this.$route.query.paperList),'this.$route.query.paperList');
    if (this.$route.query.paperList) {
      this.paperList = JSON.parse(this.$route.query.paperList);
    }
  },

  methods: {
    // 去支付
    goToUrl(id) {
      this.url = null;
      this.axios
        .get(`/degree/stuDegree/examUrl?paperId=${id}`)
        .then((res) => {
          if (res.code === 200) {
            window.open(res.result, "_blank");
          }
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.content {
  display: flex;

  .urlModel {
    height: 36px;
    line-height: 36px;
    margin: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/ExamPaperList.vue